module.exports = __webpack_public_path__ + "img/form-settings-required.2b809b6a.svg";